var m = false;
if (jQuery( window ).width() > 768){
	m = true;
	jQuery('#google_translate_element').detach().appendTo('#google_translate_element_desktop');
}
jQuery( window ).resize(function() {
	if (jQuery( window ).width() < 768 && m == false){
		m = true;
		jQuery('#google_translate_element').detach().appendTo('#google_translate_element_mobile');                            
	} else if (jQuery( window ).width() >= 768 && m == true){
		m = false;
		jQuery('#google_translate_element').detach().prependTo('#google_translate_element_desktop');                            
	}
});
function changeGoogleStyles() {
    if($('.goog-te-menu-frame').contents().find('.goog-te-menu2').length) {
        $('.goog-te-menu-frame').contents().find('.goog-te-menu2').css({
            'max-width':'100%',
            'overflow-x':'auto',
            'box-sizing':'border-box',
            'height':'auto'
        });
    } else {
        setTimeout(changeGoogleStyles, 500);
    }
}
changeGoogleStyles();
